import "./Placeholder.css"

import { ReactComponent as Logo } from "./assets/logo.svg"

export default function Placeholder() {
  return (
    <div className="placeholder">
      <Logo />
      <p>Open de app op je telefoon om verder te gaan.</p>
    </div>
  )
}
